<template>
    <!-- MY1-3079: the My Spending transaction a usage record came from
         ("Lowe's · $187.43"), linking into My Spending with the transaction
         open. Manual records have no transaction and render nothing. -->
    <UiTooltip
        v-if="isLinked"
        :text="tooltip"
        placement="top"
        :interactive="false"
        trigger-class="inline-flex max-w-full"
    >
        <template #trigger>
            <Link
                :href="href"
                class="inline-flex items-center gap-1 text-sm leading-5 text-slate-500 dark:text-slate-400 underline decoration-dotted underline-offset-2 hover:text-slate-700 dark:hover:text-slate-200 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-300 max-w-full"
                :data-source="entry.source"
                @click.stop
            >
                <Icon icon="link" class="w-3.5 h-3.5 shrink-0" />
                <span class="truncate">{{ text }}</span>
            </Link>
        </template>
    </UiTooltip>
</template>

<script setup>
import { computed } from 'vue';
import { Link, usePage } from '@inertiajs/vue3';
import Icon from '@/components/ui/icon/icon.vue';
import UiTooltip from '@/components/ui/tooltip/ui-tooltip.vue';
import filters from '@/filters';
import {
    isTransactionBacked,
    spendingTransactionUrl,
    usageRecordDataLinkTooltip,
} from '@/composables/useBenefitAutoTracking';

const props = defineProps({
    // A usage record as serialized on the benefit payload.
    entry: {
        type: Object,
        required: true,
    },
});

// The link opens My Spending, so it needs the my-spending flag.
const isLinked = computed(
    () =>
        isTransactionBacked(props.entry) &&
        usePage().props.userData?.spending_available === true
);
const href = computed(() => spendingTransactionUrl(props.entry));
const tooltip = computed(() => usageRecordDataLinkTooltip(props.entry));

const text = computed(() => {
    const merchant =
        props.entry.transaction_merchant || 'My Spending transaction';
    const amount = props.entry.transaction_amount;

    if (amount === null || amount === undefined || amount === '') {
        return merchant;
    }

    return `${merchant} · ${filters.formatSmartMoney(amount)}`;
});
</script>
